import AxiosInstance from "services/api";

export const PaymentReceiptService = {
  async getPaginate(query) {
    return await AxiosInstance.get("/private/payment-receipt", { params: query });
  },
  async getById(id) {
    return await AxiosInstance.get(`/private/payment-receipt/${id}`);
  },
  async create(payload) {
    return await AxiosInstance.post("/private/payment-receipt", payload);
  },
  async update(id, payload) {
    return await AxiosInstance.patch(`/private/payment-receipt/${id}`, payload);
  },
  async delete(id) {
    return await AxiosInstance.delete(`/private/payment-receipt/${id}`);
  },
};
